var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flux-grid',{ref:"grid",attrs:{"rows":_vm.rows,"cols":_vm.cols,"size":_vm.size,"images":_vm.images,"colors":_vm.colors,"depth":_vm.size.height,"css":_vm.gridCss}})}
var staticRenderFns = []

export { render, staticRenderFns }